import styled from 'styled-components';
import { animationShow } from '../../../../utils/animations';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-v39or3-0"
})(["display:flex;position:relative;flex-grow:1;flex-shrink:0;overflow:hidden;width:100%;height:214px;border:1px solid ", ";border-radius:", ";box-shadow:", ";background-color:", ";:hover{box-shadow:", ";}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadows.lightBlack;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.cardsBackgroundColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.shadows.extraBlack;
}, animationShow);